export const SAME_CONTRACT_ERROR = 'Erreur : transfert ou copie impossible vers le même contrat.';

export const TRANSFER_ERROR = 'Erreur lors du transfert.';